/**
 * Created by Lenovo on 2017/7/4.
 */
import React, {
    Component,
    PropTypes
} from 'react';
import Tip from 'CONFIG/component/tip'
import {
    Link
} from "react-router";
import {language, pageOption} from 'UTIL/common'
import bumpService from 'SERVICES/purifier/bump/bumpService'
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
import {timesTampsToData} from 'CONFIG/function'
import LongSearchInput from 'CONFIG/component/search/longSearchInput'
import Modal from "../../../component/modal";
export default class AirPurifierSearch  extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list:[],
            pageSize: 10,
            page: 1,
            total: 0,
            initList:''
        }
    }
    componentDidMount(){
        this.onPageChange(this.state.page, this.state.pageSize);
    }
    onPageChange(page, sizePerPage, e){
        let data = {
            "page": page,
            "pageSize": sizePerPage,
            "search": $.trim($("#search").val()),
        }
        data = JSON.stringify(data);
        bumpService.dvcBaseList({data}).then(body=>{
            console.log(body)
            this.setState({
                list:body.data.records,
                pageSize: sizePerPage,
                page: page,
                total: body.data.total,
            })
        })
    }
    search(){
        this.onPageChange(1, 10);
    }
    dataHandle(cell,row){
        return row.gmtCreat == null||''?'':timesTampsToData(row.gmtCreat);
    }
    handle(cell,row){
        return <div>
            <a  className="btn btn-success btn-sm" data-target="#initModal" data-toggle="modal"
                onClick={this.initList.bind(this,row)}>{language()['initBtn']}</a>
        </div>
    }
    initList(row){
        this.setState({
            initList : row,
        })
    }
    initSure(){
        let row = this.state.initList;
        bumpService.inItAirPurifierList(row.deviceNo,row.productId,row.factoryId).then(body=>{
            console.log(body)
            if (body.code == 8001) {
                this.onPageChange(1,10)
                $("#success_msg").text(body.msg);
                $("#success_tip").removeClass("hidden");
                $("#success_tip").focus();
                setTimeout(function () {
                    $("#success_tip").addClass("hidden");
                }, 3000);
            } else {
                $("#error_msg").text(body.msg);
                $("#error_tip").removeClass("hidden");
                $("#error_tip").focus();
                setTimeout(function () {
                    $("#error_tip").addClass("hidden");
                }, 3000);
            }
        })
    }
    reset(){
        $("#search").val('');
        this.onPageChange(1,10)
    }
    render(){
        let options = pageOption(this.state.page, this.state.pageSize);
        options['onPageChange'] = this.onPageChange.bind(this);
        return <div>
            <section className="content-header ">
                <h1>{language()['AirPurifierManagement']}
                    <small>{language()['AirPurifierList']}</small>
                </h1>
            </section>
            <section className="content">
                <div className="box box-primary color-palette-box">
                    <div className="box-header with-border">
                        <i className="fa fa-list"></i>
                        <h3 className="box-title">{language()['AirPurifierList']}</h3>
                    </div>
                    <div className="box-body">
                        <Tip ids=""/>
                        <div className="title-box">
                            <div className="clearfix">
                                <LongSearchInput id="search" name={language()['deviceID']}/>
                                <button type="button" className="btn btn-info" onClick={this.search.bind(this)}>{language()['query']}</button>
                                &nbsp;&nbsp;
                                <button type="button" className="btn btn-warning" id="reset" onClick={this.reset.bind(this)}>
                                    {language()['resetting']}
                                </button>
                            </div>

                        </div>
                        <BootstrapTable data={this.state.list} remote={true} fetchInfo={{dataTotalSize: this.state.total}} striped
                                        hover pagination={true} options={options} ref='table'>
                            <TableHeaderColumn isKey dataField='id'hidden="true"  >id </TableHeaderColumn>
                            <TableHeaderColumn dataField='factoryId' width="200">{language()['openID']}</TableHeaderColumn>
                            <TableHeaderColumn dataField='productId' width="200">{language()['productID']}</TableHeaderColumn>
                            <TableHeaderColumn dataField='deviceNo' width="200">{language()['deviceID']}</TableHeaderColumn>
                            <TableHeaderColumn dataField="dvcModel" width="120">{language()['dvcModel']}</TableHeaderColumn>
                            <TableHeaderColumn dataFormat={this.dataHandle.bind(this)} width="200">{language()['createTime']}</TableHeaderColumn>
                            <TableHeaderColumn dataFormat={this.handle.bind(this)} width="120">{language()['operation']}</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
            </section>
            <Modal modal={{"id":'initModal',"title":'initBtn',"text":"ReayToinitBtn"}}  modalSure= {this.initSure.bind(this)}/>
        </div>
    }
}


// WEBPACK FOOTER //
// ./modules/bump/back/dvcBase/airPurifierSearch.js